module.exports = __webpack_public_path__ + "eco-friendly.54cf7c36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/eco-friendly.png
// module id = 353
// module chunks = 0